module.exports = __webpack_public_path__ + "assets/1feec9190d982931da9365bf469a0bfa.wav";